<mat-tab-group
    class="integration-tabs"
    setColor
    [setColorRules]="[
        {
            color: 'primaryColour',
            style: '--mdc-tab-indicator-active-indicator-color'
        },
        {
            color: 'primaryColour',
            style: '--mat-tab-header-active-label-text-color'
        },
        {
            color: 'primaryColour',
            style: '--mat-tab-header-active-ripple-color'
        },
        {
            color: 'primaryColour',
            style: '--mat-tab-header-active-focus-label-text-color'
        },
        {
            color: 'primaryColour',
            style: '--mat-tab-header-active-hover-label-text-color'
        },
        {
            color: 'primaryColour',
            style: '--mat-tab-header-active-focus-indicator-color'
        },
        {
            color: 'primaryColour',
            style: '--mat-tab-header-active-hover-indicator-color'
        }
    ]"
    [(selectedIndex)]="selectedTabIndex"
    [preserveContent]="true"
    animationDuration="0ms"
>
    <mat-tab>
        <ng-template mat-tab-label>
            <div
                class="tab-label"
                setColor
                [class.active]="selectedTabIndex === 0"
                [setColorRules]="[
                    {
                        color: 'primaryColour',
                        style: 'color',
                        events: ['hover']
                    },
                    {
                        color: 'primaryColour',
                        style: 'color',
                        setIfClass: ['active']
                    }
                ]"
            >
                <mat-icon class="material-icons-outlined">tune</mat-icon>
                <span>{{ 'Integrations-General' | translate: {Default: 'General'} }}</span>
            </div>
        </ng-template>

        <div class="tab-surface">
            <app-integration-general-tab
                [integrationSettings]="integrationSettings"
                (saved)="settingsSaved.emit()"
            ></app-integration-general-tab>
        </div>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <div
                class="tab-label"
                setColor
                [class.active]="selectedTabIndex === 1"
                [setColorRules]="[
                    {
                        color: 'primaryColour',
                        style: 'color',
                        events: ['hover']
                    },
                    {
                        color: 'primaryColour',
                        style: 'color',
                        setIfClass: ['active']
                    }
                ]"
            >
                <mat-icon class="material-icons-outlined">vpn_key</mat-icon>
                <span>{{ 'Integrations-Connection' | translate: {Default: 'Connection'} }}</span>
            </div>
        </ng-template>

        <div class="tab-surface">
            <app-icims-integration-details-tab
                *ngIf="isIcims"
                [integrationId]="integrationSettings.id"
            ></app-icims-integration-details-tab>
            <app-payworks-integration-details
                *ngIf="isPayworks"
                [integrationId]="integrationSettings.id"
            ></app-payworks-integration-details>
            <app-payzaar-details-tab
                *ngIf="isPayzaar"
                [integrationId]="integrationSettings.id"
            ></app-payzaar-details-tab>
            <app-adp-details-tab
                *ngIf="isAdp"
                [integrationId]="integrationSettings.id"
            ></app-adp-details-tab>
        </div>
    </mat-tab>

    <mat-tab *ngIf="showMappingsTab">
        <ng-template mat-tab-label>
            <div
                class="tab-label"
                setColor
                [class.active]="selectedTabIndex === 2"
                [setColorRules]="[
                    {
                        color: 'primaryColour',
                        style: 'color',
                        events: ['hover']
                    },
                    {
                        color: 'primaryColour',
                        style: 'color',
                        setIfClass: ['active']
                    }
                ]"
            >
                <mat-icon class="material-icons-outlined">swap_horiz</mat-icon>
                <span>{{ 'Integrations-Mappings' | translate: {Default: 'Mappings'} }}</span>
            </div>
        </ng-template>

        <ng-template matTabContent>
            <div class="tab-list">
                <app-integration-mappings-tab *ngIf="integrationType === 'iCIMS'" [integrationId]="integrationSettings.id"></app-integration-mappings-tab>
                <app-payworks-mappings *ngIf="isPayworks" [integrationId]="integrationSettings.id"></app-payworks-mappings>
                <app-adp-mappings *ngIf="isAdp" [integrationId]="integrationSettings.id"></app-adp-mappings>
            </div>
        </ng-template>
    </mat-tab>

    <mat-tab *ngIf="isAdp">
        <ng-template mat-tab-label>
            <div
                class="tab-label"
                setColor
                [class.active]="selectedTabIndex === 3"
                [setColorRules]="[
                    {
                        color: 'primaryColour',
                        style: 'color',
                        events: ['hover']
                    },
                    {
                        color: 'primaryColour',
                        style: 'color',
                        setIfClass: ['active']
                    }
                ]"
            >
                <mat-icon class="material-icons-outlined">schedule</mat-icon>
                <span>{{ 'Adp-Schedules' | translate: {Default: 'Schedules'} }}</span>
            </div>
        </ng-template>

        <ng-template matTabContent>
            <div class="tab-list">
                <app-adp-schedules [integrationId]="integrationSettings.id"></app-adp-schedules>
            </div>
        </ng-template>
    </mat-tab>

    <mat-tab>
        <ng-template mat-tab-label>
            <div
                class="tab-label"
                setColor
                [class.active]="selectedTabIndex === 4"
                [setColorRules]="[
                    {
                        color: 'primaryColour',
                        style: 'color',
                        events: ['hover']
                    },
                    {
                        color: 'primaryColour',
                        style: 'color',
                        setIfClass: ['active']
                    }
                ]"
            >
                <mat-icon class="material-icons-outlined">history</mat-icon>
                <span>{{ 'Integrations-Logs' | translate: {Default: 'Logs'} }}</span>
            </div>
        </ng-template>

        <ng-template matTabContent>
            <div class="tab-list">
                <app-integration-logs-tab [integrationId]="integrationType"></app-integration-logs-tab>
            </div>
        </ng-template>
    </mat-tab>
</mat-tab-group>
